import React, { useEffect } from "react";
import "./OffersPage.css";
import { useSelector } from "react-redux";

// ── NEW GOLDEN THANK YOU SCREEN (UI ONLY) ──
const ThankYouScreen = ({ userName }) => (
  <div className="golden-ty-page">
    <div className="golden-ty-content">
      {/* Title & Subtitle */}
      <h1 className="golden-ty-title">
        Thank you, {userName?.trim() ? userName.trim().split(" ")[0] : "there"}
      </h1>
      <p className="golden-ty-subtitle">
        Your <b>Gold Loan</b> request has been received
      </p>

      {/* Contact Info Box */}
      <div className="golden-ty-contact-box">
        <p className="golden-ty-contact-text">
          <span className="phone-icon">📞</span> <b>Keep your phone handy.</b><br />
          Our lending partners will call you shortly to<br />
          help you with your Gold Loan.
        </p>
      </div>

      {/* Next Steps Card */}
      <div className="golden-ty-steps-card">
        <h3 className="golden-ty-steps-title">Next Steps</h3>
        <ul className="golden-ty-steps-list">
          <li>You will receive a call from one of our lending partners shortly.</li>
          <li>They'll guide you to a convenient branch near you.</li>
          <li>Visit with your gold and required KYC documents.</li>
          <li>Once your gold is evaluated and approved, the lender will process your loan.</li>
        </ul>
      </div>

      {/* 4 Partner Logos */}
      <div className="golden-ty-lenders-row">
        <img src="/assets/bank_img/logo/MuthootFinanceGL.png" alt="Muthoot Finance" />
        <img src="/assets/img/image 33.svg" alt="IIFL Finance" />
        <img src="/assets/bank_img/logo/ShriramFinanceGL.png" alt="Shriram Finance" />
        <img src="/assets/bank_img/logo/ManipalFintechGL.png" alt="Manipal Fintech" />
        <img src="/assets/bank_img/logo/CapriLoansGL.png" alt="Capri Global" />
        <img src="assets/bank_img/logo/MuthootFincorpGL.png" alt="Muthoot Fincorn" />
        <img src="assets/bank_img/logo/OromoneyGL.png" alt="Oro Monay" />
        <img src="/assets/bank_img/logo/RupeekGL.png" alt="Rupeek GL" />
      </div>
    </div>
  </div>
);

// ── MAIN OFFER PAGE LOGIC ──
const OfferPage = ({ formData = {}, setShowOfferHeaderLogo }) => {
  const lead = useSelector((state) => state.app.lead);

  useEffect(() => {
    if (typeof setShowOfferHeaderLogo === "function") {
      setShowOfferHeaderLogo(true);
    }
  }, [setShowOfferHeaderLogo]);

  // Resolve the user's name for the Thank You screen
  const resolvedName =
    formData?.fullName ||
    formData?.name ||
    lead?.contact_name ||
    localStorage.getItem("user_name") ||
    "";

  return (
    <div id="offer-page-v5">
      <ThankYouScreen userName={resolvedName} />
    </div>
  );
};

export default OfferPage;